import styled from "styled-components";

/*
 * The resume and abandoned cards (kitecorp/transferify-ui#3204) are the same kind of state as the delivery
 * retry: a message that takes the composer's place inside the create card, with its actions under it. They
 * share that state's frame, title, copy, notice and button primitives rather than restyling a copy of them.
 */
export {
	DeliveryErrorDetail as Notice,
	DeliveryRetryActions as Actions,
	DeliveryRetryCopy as Copy,
	DeliveryRetryRoot as CardRoot,
	DeliveryRetryTitle as Title,
	RetryDeliveryButton as PrimaryButton,
	StartOverButton as SecondaryButton,
} from "../CreateFlow.styles";

/** The one line that says what the unfinished upload holds and how far it got. */
export const Summary = styled.p`
	margin: 10px 0 0;
	font-size: 14px;
	font-weight: 600;
	line-height: 1.4;
	color: ${({theme}) => theme.tokens.ink};
	font-variant-numeric: tabular-nums;
`;
